import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { createAdminBank, deleteAdminBank, getAdminBanks, updateAdminBank } from "./slice";
import { CreateAdminBankRequest, UpdateAdminBankRequest } from "./api";

export const useAdminBanks = () => {
  const state = useAppSelector((state) => state.adminBanks);
  const dispatch = useAppDispatch();

  const getAdminBanksHandler = useCallback(
    (/* data: AdminBankRequest */) => dispatch(getAdminBanks(/* data */)),
    [dispatch]
  );

  const createAdminBankHandler = useCallback(
    (data: CreateAdminBankRequest) => dispatch(createAdminBank({ data })),
    [dispatch]
  );

  const updateAdminBankHandler = useCallback(
    (bankId: string, data: UpdateAdminBankRequest) => dispatch(updateAdminBank({ bankId, data })),
    [dispatch]
  );

  const deleteAdminBankHandler = useCallback(
    (bankId: string) => dispatch(deleteAdminBank({ bankId })),
    [dispatch]
  );
  return {
    state,
    getAdminBanks: getAdminBanksHandler,
    createAdminBank: createAdminBankHandler,
    updateAdminBank: updateAdminBankHandler,
    deleteAdminBank: deleteAdminBankHandler
  };
};
